/** sessionStorage key for a deep link consumed on next app bootstrap (cold start). */
export const PENDING_DEEP_LINK_KEY = 'aurrica:pendingDeepLink';
